var React = require('react');

function IconStarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.422 9.132a1.537 1.537 0 0 0-1.363-1.066l-5.568-.39-2.065-5.201A1.53 1.53 0 0 0 12 1.5h-.002a1.53 1.53 0 0 0-1.424.976L8.478 7.707l-5.537.36a1.536 1.536 0 0 0-1.363 1.066 1.564 1.564 0 0 0 .484 1.693l4.26 3.601-1.267 4.984a1.717 1.717 0 0 0 .658 1.83 1.67 1.67 0 0 0 1.881.059l4.394-2.784c.006-.004.012-.007.025 0l4.729 2.996a1.509 1.509 0 0 0 1.706-.053 1.56 1.56 0 0 0 .596-1.657l-1.346-5.445 4.241-3.53c.241-.201.416-.47.503-.772s.08-.623-.019-.921z","fill":"#ffc23b"}));
}

IconStarInline.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = IconStarInline;

IconStarInline.default = IconStarInline;
